module.exports = __webpack_public_path__ + "img/action_success.97007805.svg";